import { CreateSectionDto, CreateStoreDto } from "../types/dto";
import { ApiService } from "./apiService";
import { ListDto } from "../types/dto/ListDto";

export const createStore = async (data: CreateStoreDto) => {
  return await ApiService.post(`stores`, data);
}

export const getMyStores = async () => {
  return await ApiService.get(`stores`);
}

// Every store, whoever owns it.
export const getStores = async (dto: ListDto) => {
  return await ApiService.get(`stores?page=${dto.page}&size=${dto.size}`);
}

export const getStoreById = async (storeId: string) => {
  return await ApiService.get(`stores/${storeId}`);
}

export interface ListStoreCategoryProductsDto extends ListDto {
  storeId: string;
  categoryId: string;
}

// What one store sells under a category, its subcategories included.
export const getStoreCategoryProducts = async (dto: ListStoreCategoryProductsDto) => {
  return await ApiService.get(`stores/${dto.storeId}/categories/${dto.categoryId}/products?page=${dto.page}&size=${dto.size}`);
}

export const getStoreProduct = async (storeId: string, storeProductId: string) => {
  return await ApiService.get(`stores/${storeId}/store-products/${storeProductId}`);
}

// Any one section of a store's details; the parts left out stay as they are.
export interface AdminUpdateStoreDto {
  names?: { en: string; ar: string };
  workingDays?: string[];
  openingTime?: string;
  closingTime?: string;
  address?: { governorateId: string; cityId: string; fullAddressAR: string; fullAddressEN?: string };
  location?: { latitude: number; longitude: number };
}

export const updateStore = async ({ storeId, data }: { storeId: string; data: AdminUpdateStoreDto }) => {
  return await ApiService.patch(`stores/${storeId}`, data);
}
